import { LineChart } from "@mui/x-charts/LineChart";
import dayjs from "dayjs"; // Użyjemy dayjs do formatowania dat

export default function BasicLineChart(props) {
  return (
    <LineChart
      xAxis={[
        {
          data: props.xAxis,
          scaleType: "time",
          //tickInterval: 1,
          labelFormatter: (timestamp) => dayjs(timestamp).format("YYYY-MM-DD"),
        },
      ]}
      series={[{ data: props.series }]}
      width={500}
      height={300}
    />
  );
}
